import React, { useState } from 'react';
import {
  Container,
  Heading,
  Flex,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import MemberHeroSection from '@/components/membership/MemberHeroSection';
import FormModal from '@/components/modals/FormModal';
import PlayVideo from '../vc-101/PlayVideo';

const QUATERLY_REPORT_LINK =
  'https://static.levocdn.com/WGLBUT82/7146420754957908209.pdf';

const videoData = {
  title: 'Narendra Bhandari, SEA Fund',
  url: 'https://youtu.be/-t34G1mhgkY',
  id: '0aV5ivLwgqI',
  length: '1:08',
  milis_length: 68000,
  thumbnail_url: 'https://i.ytimg.com/vi/0aV5ivLwgqI/hqdefault.jpg',
};
const linksData = [
  {
    id: 'PDF_LINK',
    date: '31st December 2023',
    text: 'AIF Quarterly Activity Report (QAR) format',
    link: 'https://static.levocdn.com/WGLBUT82/AIFQuarterlyActivityReportQARv54Changeshighlighted-UpL4Wypb6IYr.pdf',
  },
  {
    id: 'PPT_LINK',
    date: '10th November 2023',
    text: 'Presentation: SEBI Circular: Reporting for AIFs',
    link: 'https://docs.google.com/presentation/d/1Ew_ld8LGXekPthrsBFz0N5OOJaFQhueF/edit#slide=id.p1',
  },
  {
    id: 'Video',
    date: '10th November 2023',
    text: 'IVCA webinar on Quarterly Reporting Format',
    link: '',
    click: 'video',
  },
  {
    id: 'REPORT_ERRORS_LINK',
    date: '13th October 2023',
    text: 'Report Errors/issues faced by AIFs',
    link: 'https://docs.google.com/forms/d/1PlKIqvZxlAGObgaB3_iF3qHl_FyeXN2vVCCOl7lNUEA/',
  },
  {
    id: 'FAQ_LINK',
    date: '6th October 2023',
    text: 'FAQs on Revised Reporting Format',
    link: 'https://static.levocdn.com/WGLBUT82/7118570197102014292.pdf',
  },
  {
    id: 'FormModal',
    date: '14th September 2023',
    text: 'Quarterly Reporting Format Download',
    link: '',
    click: 'formModal',
  },
  {
    id: 'SEBI_CIRCULAR_LINK',
    date: '14th September 2023',
    text: 'SEBI Circular on Regulatory Reporting by AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/7108375765293813130.pdf',
  },
];

const RegulatoryReportingByAif = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [isVideoOpen, setIsVideoOpen] = useState(false); // State to manage the video visibility

  const handleButtonClick = () => {
    setIsVideoOpen(true); // Open the video when the button is clicked
  };

  const onVideoClose = () => {
    setIsVideoOpen(false); // Close the video
  };
  return (
    <>
      <FormModal
        isOpen={isOpen}
        onClose={onClose}
        handleFormComplete={() => {
          window.open(QUATERLY_REPORT_LINK, '_ blank');
        }}
      />
      {isVideoOpen && (
        <PlayVideo
          isOpen={isVideoOpen}
          onClose={onVideoClose}
          video={videoData}
        />
      )}
      <Flex direction="column" rowGap="20px">
        <MemberHeroSection
          title={
            <Heading
              as="h1"
              variant="headingText"
              color="text.headingWhite"
              fontSize={{ xs: '36px', sm: '60px', md: '74px' }}
              textAlign={{ xs: 'left', sm: 'left' }}
            >
              Quarterly Reporting by AIFs
            </Heading>
          }
          type="about-us"
        />
        <Container
          maxW="container.xl"
          pt={{ xs: '50px', md: '50px' }}
          pb={{ xs: '50px', md: '50px' }}
          as="section"
          id="info"
          scrollMarginTop="140px"
        >
          <Flex direction="column" gap="2">
            {linksData.map((item) => (
              <Flex
                key={item.id}
                direction={{ base: 'column', md: 'row' }}
                cursor="pointer"
                gap={{ md: '5' }}
                onClick={() => {
                  if (item.click === 'formModal') {
                    onOpen();
                  } else if (item.click === 'video') {
                    handleButtonClick();
                  } else {
                    window.open(item?.link, '_blank');
                  }
                }}
              >
                <Flex minWidth="200px">
                  <Text
                    cursor="pointer"
                    // variant="infoText"
                    variant="heroDesc"
                    color="text.mediumBlackAlpha"
                    _hover={{
                      textDecoration: 'underline',
                    }}
                  >
                    {item.date}
                  </Text>
                  <Text
                    display={{ base: 'block', md: 'none' }}
                    cursor="pointer"
                    // variant="infoText"
                    variant="heroDesc"
                    color="text.mediumBlackAlpha"
                    _hover={{
                      textDecoration: 'underline',
                    }}
                  >
                    :&nbsp;
                  </Text>
                </Flex>
                <Flex>
                  <Text
                    display={{ base: 'none', md: 'block' }}
                    cursor="pointer"
                    // variant="infoText"
                    variant="heroDesc"
                    color="text.mediumBlackAlpha"
                    _hover={{
                      textDecoration: 'underline',
                    }}
                  >
                    :&nbsp;
                  </Text>
                  <Text
                    cursor="pointer"
                    // variant="infoText"
                    variant="heroDesc"
                    color="text.mediumBlackAlpha"
                    _hover={{
                      textDecoration: 'underline',
                    }}
                  >
                    {item.text}
                  </Text>
                </Flex>
              </Flex>
            ))}
          </Flex>
        </Container>
      </Flex>
    </>
  );
};

export default RegulatoryReportingByAif;
